import React, { useState } from "react";
import { uniqueId } from "lodash-es";
import "./ValuePickerQuestion.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/pro-solid-svg-icons";
import { SurveyQuestionProps } from "../../Components/SurveyQuestion/SurveyQuestion";
import { ValuePickerAnswerFormat } from "../../../../types/Survey";
import SurveyFormItem from "../../Components/SurveyFormItem/SurveyFormItem";
import useTranslate from "../../../../hooks/useTranslate";
import { QuestionResultModel } from "../../../../types/SurveyResult";

export default function (props: SurveyQuestionProps) {
    let [inputID] = useState(uniqueId(props.result.Identifier));
    let answerFormat = props.answerFormat as ValuePickerAnswerFormat;
    let defaultPlaceholder = useTranslate(["select-answer-prompt"])["select-answer-prompt"];
    let currentResult = props.result as QuestionResultModel;

    let classes = ["value-picker-question"];
    if (props.variant == "v2") {
        classes.push("value-picker-question-v2");
    }

    return <SurveyFormItem
        className={classes.join(" ")}
        topBorder
        bottomBorder
        label={props.label}
        labelFor={inputID}
        labelPosition={props.labelPosition}
        variant={props.variant}
        index={props.index}>
        <div className="value-picker-select-wrapper">
            <select id={inputID}
                value={currentResult.Choices && currentResult.Choices.length > 0 ? currentResult.Choices[0] : ""}
                onChange={(e) => props.onResultChange({ ...props.result, Choices: e.target.value == "" ? [] : [e.target.value] } as QuestionResultModel)} >
                <option value="" disabled>{props.placeholder || defaultPlaceholder}</option>
                {answerFormat.textChoices.map((choice, index) =>
                    <option key={index} value={choice.value}>{choice.text}</option>
                )}
            </select>
            <div className="value-picker-select-icon">
                <FontAwesomeIcon icon={faCaretDown} />
            </div>
        </div>
    </SurveyFormItem>
}